/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import { Group, GroupFromJSON, GroupFromJSONTyped, GroupToJSON } from "./Group";

/**
 *
 * @export
 * @interface GroupListResponse
 */
export interface GroupListResponse {
  /**
   *
   * @type {number}
   * @memberof GroupListResponse
   */
  offset: number;
  /**
   *
   * @type {number}
   * @memberof GroupListResponse
   */
  limit: number;
  /**
   *
   * @type {string}
   * @memberof GroupListResponse
   */
  order: string;
  /**
   *
   * @type {string}
   * @memberof GroupListResponse
   */
  sort: string;
  /**
   *
   * @type {number}
   * @memberof GroupListResponse
   */
  count: number;
  /**
   *
   * @type {Array<Group>}
   * @memberof GroupListResponse
   */
  data: Array<Group>;
}

export function GroupListResponseFromJSON(json: any): GroupListResponse {
  return GroupListResponseFromJSONTyped(json, false);
}

export function GroupListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GroupListResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    offset: json["offset"],
    limit: json["limit"],
    order: json["order"],
    sort: json["sort"],
    count: json["count"],
    data: (json["data"] as Array<any>).map(GroupFromJSON),
  };
}

export function GroupListResponseToJSON(value?: GroupListResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    offset: value.offset,
    limit: value.limit,
    order: value.order,
    sort: value.sort,
    count: value.count,
    data: (value.data as Array<any>).map(GroupToJSON),
  };
}
